/* eslint-disable no-underscore-dangle */
import { useState, useEffect, useContext } from 'react';

import { useMutation } from '@apollo/client';

import { GeneralContext } from '../../../../core/app-context/GeneralContext';
import { SET_CREDENTIALS_CLIQUE_RETIRE } from './graphql';

export function useSetCliqueRetireCredentials() {
  const { setLoading, setErrorMessage, setSuccessMessage } =
    useContext(GeneralContext);
  const [isLoading, setIsLoading] = useState(false);
  const [SetCliqueRetireCredentials, { loading: apiLoading, error: apiError }] =
    useMutation(SET_CREDENTIALS_CLIQUE_RETIRE);

  useEffect(() => {
    if (apiLoading) {
      setIsLoading(true);
      setLoading(true);
    } else {
      setIsLoading(false);
      setLoading(false);
    }
  }, [apiLoading]);

  useEffect(() => {
    if (apiError) {
      setErrorMessage('Algo deu errado, tente novamente mais tarde.');
    }
  }, [apiError]);

  async function setCliqueRetireCredentials({ storeId, credentials }) {
    try {
      const res = await SetCliqueRetireCredentials({
        variables: { credentials: { ...credentials, storeId } },
      });
      if (res.data.setCliqueRetireCredentials.code === 201) {
        setSuccessMessage('Credenciais salvas com sucesso!');
      } else {
        setErrorMessage('Erro ao linkar conta verifique os dados digitados');
      }
    } catch (e) {
      setErrorMessage('Algo deu errado, tente novamente mais tarde.');
    }
  }

  return {
    setCliqueRetireCredentials,
    loading: isLoading,
  };
}
